module.exports = __webpack_public_path__ + "static/trucks-274c41daf3f152792aa905f92aaf8e68.png";